import { render, staticRenderFns } from "./SurveyEditorContent.vue?vue&type=template&id=72dd0c5c&scoped=true"
import script from "./SurveyEditorContent.vue?vue&type=script&lang=js"
export * from "./SurveyEditorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd0c5c",
  null
  
)

export default component.exports